import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import TermsContent from "../components/TermsContent";
import { useSeo } from "../lib/seo";
import { HubFooter } from "../components/HubChrome";

const TABS = [
  { id: "escape-2026", label: "The Escape", sub: "2026 • New Orleans", to: "/escape", color: "#6EE6E6" },
  { id: "europe-2027", label: "The Europe Experience", sub: "2027 • Europe", to: "/europe", color: "#84FE2A" },
  { id: "caribbean-2027", label: "The Getaway", sub: "2027 • Caribbean", to: "/getaway", color: "#F2C04C" },
];

const TermsPage = () => {
  useSeo("/terms");
  const [active, setActive] = useState("escape-2026");
  const current = TABS.find((t) => t.id === active);

  return (
    <div className="bg-[#0A0A0A] min-h-screen">
      <div className="border-b border-white/10 bg-black">
        <div className="max-w-4xl mx-auto px-5 h-16 flex items-center justify-between">
          <Link to={current.to} data-testid="terms-back" className="flex items-center gap-2 text-white/70 hover:text-white text-sm font-cond uppercase tracking-widest">
            <ArrowLeft size={16} /> Back to Site
          </Link>
          <span className="font-cond uppercase tracking-[0.3em] text-white/40 text-xs">Terms &amp; Conditions</span>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-5 py-12">
        <h1 className="font-display uppercase text-white text-4xl sm:text-5xl">
          Terms &amp; <span className="text-[#E50914]">Conditions</span>
        </h1>
        <p className="text-white/50 mt-3 max-w-2xl">
          Select a sailing to view its terms. Each cruise shares the same core policies with
          sailing-specific payment dates.
        </p>

        <div className="flex flex-wrap gap-2 mt-8">
          {TABS.map((t) => {
            const on = active === t.id;
            return (
              <button
                key={t.id}
                onClick={() => setActive(t.id)}
                data-testid={`terms-tab-${t.id}`}
                style={on ? undefined : { color: t.color }}
                className={`flex flex-col leading-none px-4 py-2 rounded-full font-cond uppercase tracking-widest text-xs transition-colors ${
                  on ? "bg-[#E50914] text-white" : "border border-white/15 hover:bg-white/10"
                }`}
              >
                <span className="font-semibold">{t.label}</span>
                <span className="text-[9px] opacity-80 mt-0.5">{t.sub}</span>
              </button>
            );
          })}
        </div>

        <div className="mt-8 rounded-2xl border border-white/10 bg-[#111111] p-5 sm:p-8">
          <TermsContent eventId={active} />
        </div>
      </div>
      <div className="mt-16">
        <HubFooter />
      </div>
    </div>
  );
};

export default TermsPage;
